import axios from "axios";
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import ErcModal from "../../modules/shared/components/ErcModal";
import LoadingBox from "../../modules/shared/components/LoadingBox";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";
import MessageBox from "../../modules/shared/components/MessageBox";
import { convertToUrl } from "../../libraries/ercLibrary";
import "../UserForm.css";

export default function AdvantagesBoard(props) {
  // PROPS COMING FROM ProductLanding
  const {
    product,
    productCampaign,
    cartSkuItems,
    eCommerce,
    isDiscountValid,
    isPending,
  } = props;

  // CREATE refundGuarantee CONTENT
  const freeShipping = [];
  freeShipping.push(
    <>
      <h3 className="fs125 lh2 beddobck txtcenter w100p white helvetica">
        Ücretsiz Kargo
      </h3>
      <p className="w100p fs1125 margintop-1 helvetica">
        250 TL ve daha yüksek tutarlı alışverişlerde, fiyatlara kargo ücreti
        eklenmez.
      </p>
    </>
  );

  // CREATE refundGuarantee CONTENT
  const refundGuarantee = [];
  refundGuarantee.push(
    <div className="fs1125 helvetica">
      <h3 className="fs125 lh2 beddobck  txtcenter w100p white">
        {product.refundGuarantee
          ? `${product.refundGuarantee} Gün İade Garantisi`
          : "90 Gün İade Garantisi"}
      </h3>
      <p className="w100p margintop-1">Değerli Ziyaretçimiz,</p>
      <p className="w100p margintop-1">
        Herhangi bir neden ile ya da hiç nedensiz, satın aldığınız ürünü{" "}
        {product.refundGuarantee ? <u>{product.refundGuarantee}</u> : "90"} gün
        içinde iade edebilirsiniz.
      </p>
      <p className="w100p margintop-1">
        Riskiniz koca bir - 0 - Ya üründen memnun kalacaksınız ya da paranızı
        geri alacaksınız.
      </p>{" "}
      <p className="w100p margintop-1">
        İade başlatmak için{" "}
        <Link className="beddo-color" to="/musteri-hizmetleri">
          Müşteri Hizmetleri
        </Link>{" "}
        sayfasını ziyaret edebilirsiniz.
      </p>
      <div className="signature margintop-1 w100p">
        <h3>Saygılarımla</h3>
        <h3>Tuğba Ö.</h3>
        <h3>Müşteri Hizmetleri Yöneticisi</h3>
      </div>
      <p className="fs1 margintop-1">
        <span className="bold-font">Not:</span> 90 gün iade garantisi sadece{" "}
        <span className="bold-font">beddo.com</span> sitemizden yapacağınız
        alışverişlerde geçerlidir. Trendyol vb. pazaryeri sitelerinden ya da
        medikal mağazalardan aldığınız beddo™ ürünlerinde, pazaryeri sitesinin
        ve mağazanın iade koşulları geçerli olur.
      </p>
    </div>
  );

  // CREATE ebooksGift CONTENT
  const ebooksGift = [];
  ebooksGift.push(
    <div className="fs1125 helvetica">
      <h3 className="fs126 lh2 beddobck  txtcenter w100p white">
        Hediye E-Kitaplar
      </h3>
      <p className="w100p margintop-1">
        Müşteri hizmetleri sayfanıza girin ve "
        <u className="green">Master Chef Sedef'in Diyeti</u>" kitabını okuyun.
        Sedef Hanım'ın sağlıklı zayıflama tecrübelerinden yararlanın.
      </p>
      <p className="w100p margintop-1">
        Buna ek olarak "
        <u className="green">Daha İyi Uyumaya Yardımcı 5 Yiyecek</u>" ve "
        <u className="green">Daha İyi Bir Uyku İçin 140 Yol</u>" e-kitaplarını
        okuyun ve uyku kalitenizi artırın.
      </p>
    </div>
  );

  // CREATE buyOneGetDifferentOneFree CONTENT
  const buyOneGetDifferentOneFree = [];
  buyOneGetDifferentOneFree.push(
    <div className="1125 helvetica">
      {productCampaign && productCampaign.name && (
        <>
          <h3 className="fs125 lh2 beddobck  txtcenter w100p white">
            1 Alana 1 {productCampaign.name.split("|")[1]} Bedava
          </h3>
          <p className="w100p fs1125 margintop-1">
            Sepete eklediğiniz {product.name.split("|")[1]}
            kadar bedava <u>{productCampaign.name.split("|")[1]}</u> kazanın.
          </p>
          <Link
            to={`/urun/${convertToUrl(productCampaign.name)}/${
              productCampaign._id
            }`}
            target="_blank"
            className="row-left-align-center-nowrap margintop-1 beddo-border lightbck"
          >
            <img
              className="small-image marh"
              src={productCampaign.defaultImages[0]}
              alt={productCampaign.name}
            />
            <h2 className="fs125">{productCampaign.name}</h2>
          </Link>
        </>
      )}
    </div>
  );

  // CREATE buyOneGetOneFree CONTENT
  const buyOneGetOneFree = [];
  buyOneGetOneFree.push(
    <>
      <h3 className="fs1-6 lh2 beddobck  txtcenter w100p white">
        1 Alana 1 Bedava
      </h3>
      <p className="w90p fs15 margintop-1">
        Sepete eklediğiniz adet kadar bedava <u>{product.name.split("|")[1]}</u>{" "}
        kazanın.
      </p>
    </>
  );

  // CREATE multiPurchaseDiscount CONTENT
  const multiPurchaseDiscount = [];
  multiPurchaseDiscount.push(
    <div className="helvetica fs1125">
      {isPending?.isTherePending === "YES" ? (
        <>
          <h3 className="lh2 beddobck  txtcenter w100p white bold-font">
            Ek Sipariş İndirimi
          </h3>
          <p className="w100p margintop-1">
            Ana siparişiniz paketlenene kadar yapacağınız tüm alışverişler "Ek
            Adet Fiyatı" ile gerçekleşir.
          </p>
          <p className="w100p margintop-1">
            Bu imkanı kaçırmamak için çabuk olmalısınız. Çünkü, beddo™ ekibi
            alınan tüm siparişleri hızlıca paketlemek için çok çalışıyor.
          </p>
          <p className="w100p margintop-1">
            Ana siparişiniz paketlenir paketlenmez üstü çizili kırmızı fiyatlar
            geçerli olur.
          </p>
          <p className="margintop-1 greenbcklight padq bold-font">
            Süre dolmadan ek siparişinizi oluşturun. Kaliteli beddo™ ürünlerine
            uygun fiyatlarla sahip olmanın keyfini yaşayın.
          </p>
          <p className="w100p margintop-1">
            beddo™ rahatını sevdiklerinize de yaşatmak için ya da farklı
            mekanlarda elinizin altında her an hazır bir beddo™ olması için ek
            siparişler oluşturun.
          </p>
        </>
      ) : isDiscountValid ? (
        <>
          <h3 className="lh2 beddobck  txtcenter w100p white bold-font">
            Sınırlı Süreli İndirim
          </h3>
          <div className="w100p margintop-1">
            {cartSkuItems.length === 1 && cartSkuItems[0].qty === "1" ? (
              <>
                <p className="w100p margintop-1">
                  Sepetinizde 1 adet beddo™{" "}
                  {cartSkuItems &&
                    cartSkuItems.length > 0 &&
                    cartSkuItems[0].name.split("|")[1]}{" "}
                  var.
                </p>
                <p className="w100p margintop-1">
                  Aynı ürünün adetini artırarak ya da yeni ürünler ekleyerek "Ek
                  Adetler" fiyatından yararlanabilirsiniz.
                </p>
                <p className="w100p margintop-1">
                  beddo™ rahatını sevdiklerinize de yaşatmak için ya da farklı
                  mekanlarda elinizin altında her an hazır bir beddo™ olması
                  için adet artırın.
                </p>
                <p className="w100p margintop-1">
                  Evde, arabada, ofiste vb. beddo™ rahatını yaşayın ve yaşatın.
                </p>
                <p className="margintop-1 greenbcklight padq bold-font">
                  Süre dolmadan siparişinizi oluşturun ve tasarruf edin.
                </p>
              </>
            ) : (
              <div className="w100p margintop-1">
                <p className="w100p margintop-1">
                  Süre dolmadan sepetinize ürünler ekleyin.
                </p>
                <p className="w100p margintop-1">
                  İlk adet ve ek adetler fiyatı ile alışveriş yaparak tasarruf
                  edin.
                </p>
                <p className="w100p margintop-1">
                  beddo™ rahatını sevdiklerinize de yaşatmak için ya da farklı
                  mekanlarda elinizin altında her an hazır bir beddo™ olması
                  için adet artırın.
                </p>
                <p className="w100p margintop-1">
                  Evde, arabada, ofiste vb. beddo™ rahatını yaşayın ve yaşatın.
                </p>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <h3 className="lh2 beddobck  txtcenter w100p white bold-font">
            BEDDO20 İndirim Kodu
          </h3>
          <p className="w90p margintop-1">
            <span className="green">BEDDO20</span> indirim kodu ile indirimli
            alışveriş yapın.
          </p>
          <p className="w90p margintop-1">
            beddo™ rahatını sevdiklerinize de yaşatmak için ya da farklı
            mekanlarda elinizin altında her an hazır bir beddo™ olması için adet
            artırın.
          </p>
          <p className="w90p margintop-1">
            Evde, arabada, ofiste vb. beddo™ rahatını yaşayın ve yaşatın.
          </p>
        </>
      )}
    </div>
  );

  // CREATE freeInt CONTENT
  // BRING IN INSTALLMENT INFO FROM IYZICO
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [installmentInfo, setInstallmentInfo] = useState(false);

  // REACT STATE TO MANAGE IF REQUEST IS MADE REMOVE INSTALLMENT MESSAGE
  const [remove, setRemove] = useState(false);
  const handleInstalmentsInfo = useCallback(async () => {
    const val = "123456 ";
    return await axios
      .get(`/api/orders/iyzicoinstallmentinfo/${val}/${product.defaultPrice}`)
      .then((response) => {
        if (response.data.status === "failure") {
          setInstallmentInfo(response.data);
          setLoading(false);
          setRemove(true);
        } else if (response.data.status === "success") {
          setInstallmentInfo(response.data);
          setLoading(false);
          setError(false);
          setRemove(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        setRemove(true);
      });
  }, [product]);

  const freeInt = [];
  freeInt.push(
    <>
      <h3 className="fs1-6 lh2 beddobck txtcenter w100p white">
        Vade Farksız 3 Taksit
      </h3>
      <p className="w95p fs1 margintop-1">
        Kredi kartınız ile hem hesaplı hem de güvenli ödeme yapın.
      </p>
      <div className="col fs1">
        {!remove ? (
          "Taksit seçenekleri kart numaranızı girdikten sonra görünecektir."
        ) : loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox>
            Bu kart için işleminiz tek çekim olarak yapılabiliyor.
          </MessageBox>
        ) : (
          installmentInfo &&
          installmentInfo.installmentDetails.map((detail, index) => {
            return (
              <table
                key={index + 100}
                className="installment-table margintop-1"
              >
                <thead>
                  <tr>
                    <th className="table-headline txtmid">
                      {detail.cardFamilyName}
                    </th>
                    <th className="table-headline txtright"></th>
                  </tr>
                </thead>
                <tbody>
                  {installmentInfo.installmentDetails[0].installmentPrices.map(
                    (installment, index) => {
                      return (
                        <tr key={index + 50}>
                          <td className="w50p txtleft">
                            {index === 0
                              ? "Tek Çekim"
                              : `${installment.installmentNumber} x ${installment.installmentPrice} TL`}
                          </td>
                          <td className="form-totalprice">
                            {installment.totalPrice} TL
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            );
          })
        )}
        {loading && <LoadingBoxWithoutText></LoadingBoxWithoutText>}
      </div>
    </>
  );

  return (
    <div
      className={
        eCommerce
          ? "w90p col-webkit marq white-border3 marb1"
          : "w90p col-webkit marq"
      }
    >
      <div className="w100p col-webkit marb1 lightbeddobck">
        <h2 className="h2cnp marh green">Avantajlarınız</h2>
      </div>
      {eCommerce ? "" : <i className="far fa-handshake beddo-color fs6"></i>}
      <div
        className={
          eCommerce ? "row-space-evenly-align-self-wrap marb-5" : "col w100p"
        }
      >
        <div className={eCommerce ? "w30p" : "w100p"}>
          <ErcModal
            modalTitleDivWidth={"100%"}
            modalTitle={() => (
              <button type="button" className="info-buttons">
                Ücretsiz Kargo
                {eCommerce ? (
                  ""
                ) : (
                  <i className="far fa-question-circle green fs1125 marq"></i>
                )}
              </button>
            )}
            modalTitleFontSize={"1rem"}
            modalTitleLineHeight={"2rem"}
            contentTitleFontSize={"1.35rem"}
            contentTitle={"Bedava Kargo Olmazsa Olmazımız"} // MUST RENDER A WHITE SPACE TO KEEP CLOSE ICON VISIBLE
            content={freeShipping}
            modalParagFontSize={"1.25rem"}
          />
        </div>

        {product.refundGuarantee && (
          <div className={eCommerce ? "w30p" : "w100p"}>
            <ErcModal
              modalTitleDivWidth={"100%"}
              modalTitle={() => (
                <button type="button" className="info-buttons">
                  {product.refundGuarantee
                    ? `${product.refundGuarantee} Gün İade`
                    : "90 Gün İade"}
                  {eCommerce ? (
                    ""
                  ) : (
                    <i className="far fa-question-circle green fs1125 marq"></i>
                  )}
                </button>
              )}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={"Uzun Süreli İade Garantisi İle Riskiniz SIFIR"}
              content={refundGuarantee}
              modalParagFontSize={"1.25rem"}
            />
          </div>
        )}
        {product.ebooksGift && (
          <div className={eCommerce ? "w30p" : "w100p"}>
            <ErcModal
              modalTitleDivWidth={"100%"}
              modalTitle={() => (
                <button type="button" className="info-buttons">
                  Hediye Kitaplar
                  {eCommerce ? (
                    ""
                  ) : (
                    <i className="far fa-question-circle green fs1125 marq"></i>
                  )}
                </button>
              )}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={"Basit Bilgilerle Yaşam Kalitenizi Artırın"}
              content={ebooksGift}
              modalParagFontSize={"1.25rem"}
            />
          </div>
        )}
        {product.buyOneGetOneFree && product._id !== product.freeProductId && (
          <div className={eCommerce ? "w30p" : "w100p"}>
            <ErcModal
              modalTitleDivWidth={"100%"}
              modalTitle={() => (
                <button type="button" className="info-buttons">
                  1 Alana 1{" "}
                  {productCampaign &&
                    productCampaign.name &&
                    productCampaign.name.split("|")[1]}{" "}
                  Bedava
                  {eCommerce ? (
                    ""
                  ) : (
                    <i className="far fa-question-circle green fs1125 marq"></i>
                  )}
                </button>
              )}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={
                "Kullanışlı Ve Bedava beddo™ Ürünleri İle Huzur Bulun"
              }
              content={buyOneGetDifferentOneFree}
              modalParagFontSize={"1.25rem"}
            />
          </div>
        )}
        {product.buyOneGetOneFree && product._id === product.freeProductId && (
          <div className={eCommerce ? "w30p" : "w100p"}>
            <ErcModal
              modalTitleDivWidth={"100%"}
              modalTitle={() => (
                <button type="button" className="info-buttons">
                  1 Alana 1 Bedava
                  {eCommerce ? (
                    ""
                  ) : (
                    <i className="far fa-question-circle green fs1125 marq"></i>
                  )}
                </button>
              )}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={" "}
              content={buyOneGetOneFree}
              modalParagFontSize={"1.25rem"}
            />
          </div>
        )}
        {product.multiPurchaseDiscount && (
          <div className={eCommerce ? "w30p" : "w100p"}>
            <ErcModal
              modalTitleDivWidth={"100%"}
              modalTitle={() => (
                <button type="button" className="info-buttons">
                  Karlı İndirimler
                  {eCommerce ? (
                    ""
                  ) : (
                    <i className="far fa-question-circle green fs1125 marq"></i>
                  )}
                </button>
              )}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={
                "Kaliteli Bir Ürüne İndirimli Sahip Olmanın Mutluluğunu Yaşayın"
              }
              content={multiPurchaseDiscount}
              modalParagFontSize={"1.25rem"}
            />
          </div>
        )}
        <div className={eCommerce ? "w30p" : "w100p"}>
          <ErcModal
            modalTitleDivWidth={"100%"}
            modalTitle={() => (
              <button
                type="button"
                className="info-buttons"
                onClick={() => handleInstalmentsInfo()}
              >
                Taksit Seçeneği
                {eCommerce ? (
                  ""
                ) : (
                  <i className="far fa-question-circle green fs1125 marq"></i>
                )}
              </button>
            )}
            modalTitleFontSize={"1rem"}
            modalTitleLineHeight={"2rem"}
            contentTitleFontSize={"1.35rem"}
            contentTitle={"beddo™ Keyfi Peşin Ödemesi İse Faizsiz 3 Taksit"}
            content={freeInt}
            modalParagFontSize={"1.25rem"}
          />
        </div>
      </div>
    </div>
  );
}
